// extracted by mini-css-extract-plugin
module.exports = {"marker":"CustomMarker-hashed__marker__2RHHm","icon":"CustomMarker-hashed__icon__2QAlS"};